import styled from "styled-components";
import { ColorV2 } from "config/colors";
import { TypographyV2 } from "config/font";

export const ModalBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  height: 100%;
`;

export const FieldStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const FieldLabel = styled.span`
  ${TypographyV2.b2};
  color: ${ColorV2.Blue2};
`;

export const ActionRow = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  width: 100%;
`;
